import React, {useEffect, useState} from 'react';
import './App.css';
import {signInWithPopup, signOut} from 'firebase/auth';
import {doc, setDoc, getDoc, serverTimestamp} from 'firebase/firestore';
import {auth, googleProvider, twitterProvider, db, getUserByUID, checkUserByAnyUID, getUserByEmail} from './firebase';
import {useAccount} from "wagmi";
import {ConnectKitButton} from "connectkit";
import {Dashboard} from './Dashboard';

function App() {
  const [googleAccount, setGoogleAccount] = useState(null);
  const [twitterAccount, setTwitterAccount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [savedUserData, setSavedUserData] = useState(null);
  const {address,} = useAccount();

  const handleGoogleLogin = async () => {
    try {


      setLoading(true);
      const result = await signInWithPopup(auth, googleProvider);
      const userData = result.user;

      // Get Firebase Auth UID (not Google Account UID)
      const currentUser = auth.currentUser;

      setGoogleAccount({
        uid: currentUser.uid, // Use Firebase Auth UID
        email: userData.email,
        displayName: userData.displayName,
        photoURL: userData.photoURL
      });


      // // Check if user exists using Firebase Auth UID
      // const availableAccount = await getUserByUID(currentUser.uid);
      // if (!!availableAccount) {
      //   setSavedUserData(availableAccount)
      //   setIsLoggedIn(true);
      //   handleOnUserData(availableAccount)
      //   return
      // }

    } catch (error) {
      console.error('Google login error:', error);
      // alert('Google login failed: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTwitterLogin = async () => {
    try {

      setLoading(true);
      const result = await signInWithPopup(auth, twitterProvider);
      const userData = result.user;
      // Get screenName from reloadUserInfo
      const screenName = userData.reloadUserInfo?.screenName || userData.displayName;

      setTwitterAccount({
        username: userData.displayName,
        screenName: screenName,
        email: userData.email,
        photoURL: userData.photoURL
      });

      const currentUser = auth.currentUser;
      const availableAccount = await getUserByUID(currentUser.uid);
      if (!!availableAccount) {
        setSavedUserData(availableAccount)
        setIsLoggedIn(true);
        handleOnUserData(availableAccount)
        return
      }


    } catch (error) {
      console.error('Twitter login error:', error);
      // alert('Twitter login failed: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.clear()
      setGoogleAccount(null);
      setTwitterAccount(null);
      setIsLoggedIn(false);
      setSavedUserData(null);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleWalletSubmit = async () => {
    if (!address.trim()) {
      alert('Please connect the wallet');
      return;
    }

    if (!googleAccount || !twitterAccount) {
      alert('Please connect both Google and Twitter accounts first');
      return;
    }

    try {
      setLoading(true);
      const currentUser = auth.currentUser;
      const userRef = doc(db, "user", currentUser.uid);

      // Prepare user data to save
      const userData = {
        uid: currentUser.uid, // Firebase Auth UID
        email: googleAccount.email,
        displayName: googleAccount.displayName,
        photoURL: googleAccount.photoURL,
        twitter_display_name: twitterAccount.username,
        twitter_screen_name: twitterAccount.screenName,
        wallet_address: address,
        createdAt: serverTimestamp(),
      };
      await setDoc(userRef, userData);
      handleOnUserData(userData);
      // Save user data and navigate to home screen
      setSavedUserData(userData);
      setIsLoggedIn(true);

    } catch (error) {
      console.error('Error saving to Firestore:', error);
      // alert('Failed to save data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  function handleOnUserData(user) {
    localStorage.setItem('userData', JSON.stringify(user));
  }

  useEffect(() => {
    const data = localStorage.getItem('userData')
    if (!!data) {
      const userData = JSON.parse(data)
      setSavedUserData(userData);
      setIsLoggedIn(true);
    }
  }, []);

  // Calculate current step
  const getCurrentStep = () => {
    if (!googleAccount) return 1;
    if (!twitterAccount) return 2;
    if (!address) return 3;
    return 4;
  };

  const currentStep = getCurrentStep();

  // Show HomeScreen after successful login
  if (isLoggedIn && savedUserData) {
    return <Dashboard userData={savedUserData} onLogout={handleLogout}/>;
  }

  return (
    <main className="relative min-h-screen 2xl:h-screen flex items-center justify-center overflow-hidden bg-black p-4 sm:p-6 md:p-8 xl:p-4">
      {/* Gorgeous black → gold gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#1a1200] via-40% to-[#facc15] opacity-95"/>

      {/* Soft glow overlay */}
      <div
        className="absolute bottom-0 w-full h-[60vh] bg-gradient-to-t from-yellow-400/60 via-yellow-500/20 to-transparent blur-3xl mix-blend-screen"/>


      {/* Card */}
      <section
        className="relative z-10 max-w-screen-2xl w-full h-full 2xl:h-[85vh] rounded-2xl sm:rounded-3xl bg-black border border-yellow-400/30 shadow-[0_0_60px_-10px_rgba(255,204,0,0.5)] p-4 sm:p-6 md:p-8 xl:p-3 text-center 2xl:overflow-hidden">

        {/* Horizontal Layout Container - Only for Desktop */}
        <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8 2xl:h-full">

          {/* Left Side - Image */}
          <div className="flex-shrink-0 sm:w-1/2">
            <img
                src="/donkey.jpeg"
                alt="Carrot vs Stick mascot"
                className="mx-auto w-45 h-auto sm:w-full sm:max-w-xl sm:max-h-[70vh] sm:object-contain"
            />
          </div>

          {/* Right Side - Content */}
          <div className="flex-1 w-full sm:w-1/2 sm:flex sm:flex-col 2xl:justify-center sm:pr-6">
            {/* Progress Stepper - Mobile Only */}
            <div className="mb-3 sm:mb-4 xl:mb-1 2xl:mb-2">
          <div className="flex items-center justify-between mb-3 sm:mb-4">
            {/* Step 1: Google */}
            <div className="flex flex-col items-center flex-1">
              <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-base font-bold transition-all ${
                currentStep > 1 ? 'bg-green-500 text-white' : currentStep === 1 ? 'bg-yellow-400 text-black animate-pulse' : 'bg-gray-600 text-gray-400'
              }`}>
                {currentStep > 1 ? '✓' : '1'}
              </div>
              <p className={`text-[10px] sm:text-xs mt-1 sm:mt-2 font-medium ${currentStep === 1 ? 'text-yellow-400' : currentStep > 1 ? 'text-green-400' : 'text-gray-500'}`}>
                Google
              </p>
            </div>

            {/* Connector Line */}
            <div className={`flex-1 h-0.5 sm:h-1 mx-1 sm:mx-2 transition-all ${currentStep > 1 ? 'bg-green-500' : 'bg-gray-600'}`}></div>

            {/* Step 2: Twitter */}
            <div className="flex flex-col items-center flex-1">
              <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-base font-bold transition-all ${
                currentStep > 2 ? 'bg-green-500 text-white' : currentStep === 2 ? 'bg-yellow-400 text-black animate-pulse' : 'bg-gray-600 text-gray-400'
              }`}>
                {currentStep > 2 ? '✓' : '2'}
              </div>
              <p className={`text-[10px] sm:text-xs mt-1 sm:mt-2 font-medium ${currentStep === 2 ? 'text-yellow-400' : currentStep > 2 ? 'text-green-400' : 'text-gray-500'}`}>
                Twitter
              </p>
            </div>

            {/* Connector Line */}
            <div className={`flex-1 h-0.5 sm:h-1 mx-1 sm:mx-2 transition-all ${currentStep > 2 ? 'bg-green-500' : 'bg-gray-600'}`}></div>

            {/* Step 3: Wallet */}
            <div className="flex flex-col items-center flex-1">
              <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-base font-bold transition-all ${
                currentStep > 3 ? 'bg-green-500 text-white' : currentStep === 3 ? 'bg-yellow-400 text-black animate-pulse' : 'bg-gray-600 text-gray-400'
              }`}>
                {currentStep > 3 ? '✓' : '3'}
              </div>
              <p className={`text-[10px] sm:text-xs mt-1 sm:mt-2 font-medium ${currentStep === 3 ? 'text-yellow-400' : currentStep > 3 ? 'text-green-400' : 'text-gray-500'}`}>
                Wallet
              </p>
            </div>

            {/* Connector Line */}
            <div className={`flex-1 h-0.5 sm:h-1 mx-1 sm:mx-2 transition-all ${currentStep > 3 ? 'bg-green-500' : 'bg-gray-600'}`}></div>

            {/* Step 4: Complete */}
            <div className="flex flex-col items-center flex-1">
              <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-xs sm:text-base font-bold transition-all ${
                currentStep === 4 ? 'bg-yellow-400 text-black animate-pulse' : 'bg-gray-600 text-gray-400'
              }`}>
                4
              </div>
              <p className={`text-[10px] sm:text-xs mt-1 sm:mt-2 font-medium ${currentStep === 4 ? 'text-yellow-400' : 'text-gray-500'}`}>
                Done
              </p>
            </div>
          </div>

          {/* Current Step Instruction */}
          <div className="bg-yellow-400/10 border border-yellow-400/30 rounded-lg p-2.5 sm:p-3">
            <p className="text-xs sm:text-sm text-yellow-300 font-medium">
              {currentStep === 1 && '👉 Step 1: Connect your Google account'}
              {currentStep === 2 && '👉 Step 2: Connect your Twitter (X) account'}
              {currentStep === 3 && '👉 Step 3: Connect your wallet'}
              {currentStep === 4 && '✨ Almost there! Click "Complete Login" to finish'}
            </p>
          </div>
        </div>

        <p className="mb-3 sm:mb-4 xl:mb-1 2xl:mb-2 text-neutral-300">
          Connect both accounts and your wallet to start earning Carrots — and dodge the Sticks.
        </p>

        {/* Buttons */}
        <div className="mt-2 sm:mt-3 md:mt-4 xl:mt-1 2xl:mt-2 flex flex-col gap-3 sm:gap-4 xl:gap-3 2xl:gap-4">
          {/* Google */}
          <button
            disabled={!!googleAccount}
            onClick={handleGoogleLogin}
            className={`flex items-center justify-center gap-2 sm:gap-3 w-full bg-yellow-400 hover:bg-yellow-300
               text-black font-semibold h-10 sm:h-12 xl:h-9 2xl:h-10 rounded-lg sm:rounded-xl transition
               shadow-[0_4px_0_rgba(180,134,0,1)] sm:shadow-[0_6px_0_rgba(180,134,0,1)]
               hover:translate-y-[1px] active:translate-y-[2px] text-sm sm:text-base ${!!googleAccount ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}
          >
            <img src="images/gg.png" alt="Google" className="w-4 h-4 sm:w-5 sm:h-5" />
            {googleAccount ? <div className="text-left">
              <p className="text-xs sm:text-sm font-bold">Google connected</p>
              <p className="text-[10px] sm:text-xs truncate max-w-[200px] sm:max-w-none">{googleAccount.email}</p>
            </div> : <span>Connect Google</span>}
          </button>

          {/* Twitter (X) */}
          <button
            disabled={!googleAccount || !!twitterAccount}
            onClick={handleTwitterLogin}
            className={`flex items-center justify-center gap-2 sm:gap-3 w-full bg-yellow-400 hover:bg-yellow-300
              text-black font-semibold h-10 sm:h-12 xl:h-9 2xl:h-10 rounded-lg sm:rounded-xl transition
              shadow-[0_4px_0_rgba(180,134,0,1)] sm:shadow-[0_6px_0_rgba(180,134,0,1)]
              hover:translate-y-[1px] active:translate-y-[2px] text-sm sm:text-base ${!googleAccount ? 'opacity-30 cursor-not-allowed pointer-events-none' : twitterAccount ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}
          >
            <XIcon className="w-4 h-4 sm:w-5 sm:h-5"/>

            {twitterAccount ? <div className="text-left">
              <p className="text-xs sm:text-sm font-bold">X connected</p>
              <p className="text-[10px] sm:text-xs">@{twitterAccount.screenName}</p>
            </div> : <span>Connect X (Twitter)</span>}

          </button>

          {/* Wallet */}
          <ConnectKitButton.Custom>
            {({show}) => (
              <button
                disabled={!googleAccount || !twitterAccount || !!address}
                onClick={() => show()}
                className={`flex items-center justify-center gap-2 sm:gap-3 w-full bg-yellow-400 hover:bg-yellow-300
                   text-black font-semibold h-10 sm:h-12 xl:h-9 2xl:h-10 rounded-lg sm:rounded-xl transition
                   shadow-[0_4px_0_rgba(180,134,0,1)] sm:shadow-[0_6px_0_rgba(180,134,0,1)]
                   hover:translate-y-[1px] active:translate-y-[2px] text-sm sm:text-base ${!googleAccount || !twitterAccount ? 'opacity-30 cursor-not-allowed pointer-events-none' : !!address ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}
              >
                <WalletIcon className="w-4 h-4 sm:w-5 sm:h-5"/>
                {address ? (
                  <div className="text-left">
                    <p className="text-xs sm:text-sm font-bold">Wallet connected</p>
                    <p className="text-[10px] sm:text-xs truncate max-w-[200px] sm:max-w-none">{`${address.slice(0, 6)}...${address.slice(-6)}`}</p>
                  </div>
                ) : (
                  <span>Connect Wallet</span>
                )}
              </button>
            )}
          </ConnectKitButton.Custom>
          {
            !!googleAccount && !!twitterAccount && !!address && (
              <button
                disabled={loading}
                onClick={handleWalletSubmit}
                className={`flex items-center justify-center gap-2 sm:gap-3 w-full bg-yellow-400 hover:bg-yellow-300
                   text-black font-semibold h-10 sm:h-12 xl:h-9 2xl:h-10 rounded-lg sm:rounded-xl transition
                   shadow-[0_4px_0_rgba(180,134,0,1)] sm:shadow-[0_6px_0_rgba(180,134,0,1)]
                   hover:translate-y-[1px] active:translate-y-[2px] text-sm sm:text-base ${!!loading ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}
              >
                <span>Complete Login</span>
              </button>

            )
          }
          <button
            onClick={() => (window.location.href = "/rules")}
            className="flex items-center justify-center gap-2 sm:gap-3 w-full bg-black text-black font-semibold h-10 sm:h-12 xl:h-9 2xl:h-10 rounded-lg sm:rounded-xl transition hover:translate-y-[1px] active:translate-y-[2px] border border-yellow-400 hover:bg-yellow-400/10 cursor-pointer"
          >
            <span className="text-xl sm:text-2xl">📜</span>
            <span className="text-base sm:text-lg font-bold text-yellow-400">View Rules</span>
          </button>
        </div>

        {/* Footer */}
        <div className="mt-4 sm:mt-5 xl:mt-3 2xl:mt-4 space-y-1 sm:space-y-2 xl:space-y-1">
          <p className="text-[10px] sm:text-xs text-neutral-400 leading-relaxed max-w-lg mx-auto text-center px-2">
            <span className="font-semibold text-yellow-400">Disclaimer:</span> $CARROT, $STICK, and $MAGIC have no monetary value.
            Participation implies consent to use of email, Twitter handle, and wallet address for marketing purposes.
            Token rewards are arbitrary and may change anytime. Not financial advice — just vibes. 🥕🪵🪄
          </p>
          <p className="text-xs sm:text-sm text-neutral-500">
            Powered by Some one — © 2025 <span className="text-yellow-400">Carrot vs Stick</span>
          </p>
            </div>
          </div>
        </div>
      </section>
    </main>

  );
}



function XIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path
        d="M18.9 3H21l-6.6 7.5L22 21h-5.2l-4-5-4.6 5H3.1l7.2-8L2 3h5.3l3.6 4.7L18.9 3Zm-1.8 16.2h1.4L7.9 4.7H6.4l10.7 14.5Z"/>
    </svg>
  );
}

function WalletIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path
        d="M3 6.5A2.5 2.5 0 0 1 5.5 4H18a1 1 0 1 1 0 2H5.5A.5.5 0 0 0 5 6.5V8h13.5A2.5 2.5 0 0 1 21 10.5v7A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-11Z"/>
      <path d="M16 13.25a1.25 1.25 0 1 0 0 2.5h2.25a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75H16Z"/>
    </svg>
  );
}

export default App;
